// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1uqdT","error":"Textarea_error__foAx9","readonly":"Textarea_readonly__or-EQ","disabled":"Textarea_disabled__3FESn"};